enum ClaimSteps {
	POLICY_INFORMATION = 'Policy Information',
	CLAIM_RECENTLY_SUBMITTED = 'Claim Recently Submitted',
	WHO_SUBMITS_THE_CLAIM = 'Who Is Submitting The Claim?',
	WHAT_CAUSE_OF_LOSS = 'What Was The Cause Of Loss?',
	HAD_CLAIM_BEFORE = 'Have You Had A Claim Of This Type Before?',
	INSURED_CONTACT_DETAILS = 'Insured Contact Details',
	DOLLAR_VALUE_AND_DATE_OF_LOSS = 'Estimated Dollar Value And Date Of Loss',
	OTHER_INSURANCE = 'Is There Other Insurance For The Damaged Property?',
	ADDITIONAL_CONTACT_DETAILS = 'Additional Contact Details',
	WHAT_HAPPENED = 'What Happened?',
	PICTURES_OF_DAMAGED_PROPERTY = 'Pictures Of Damaged Property',
	DISCLOSURES_AND_ACKNOWLEDGEMENTS = 'Disclosures And Acknowledgements',
	CLAIM_SUBMITTED = 'Your Claim Has Been Submitted',
	CLAIM_CENTER = 'Claim Center',
	CLAIM_INFORMATION = 'Claim Information',
	NEW_CLAIM_CONFIRMATION = 'Start New Claim',
	NONE = 'None'
}

export default ClaimSteps;